import { denormalize } from "normalizr";
import { clientsSchema } from "./applications-list-schema";
export const APPLICATIONS_BY_CLIENT = "APPLICATIONS_BY_CLIENT";
export const CLIENTS_LOADED = "CLIENTS_LOADED";
export const GET_CURRENT_FILTERS = "GET_CURRENT_FILTERS";
export const GET_CLIENT_INFORMATION_FOR_TRANSFER = "GET_CLIENT_INFORMATION_FOR_TRANSFER";
export const APPLICATION_BY_ID = "APPLICATION_BY_ID";
export const SHOULD_VERIFY_IMPORT_EMAIL = "SHOULD_VERIFY_IMPORT_EMAIL";
export const IMPORT_VERIFICATION_EMAIL = "IMPORT_VERIFICATION_EMAIL";
export const APPLICATION_CONSENT_OBTAINED_DATE = "APPLICATION_CONSENT_OBTAINED_DATE";
export default {
  [APPLICATIONS_BY_CLIENT]: state => clientUsername => {
    const {
      byId
    } = state.clients;
    const [client] = denormalize([clientUsername], [clientsSchema], {
      clients: byId,
      applications: state.applications.byId
    });
    return client.applications;
  },
  [APPLICATION_CONSENT_OBTAINED_DATE]: state => applicationId => {
    return state.applications.byId[applicationId].consentObtainedDate;
  },
  [APPLICATION_BY_ID]: state => id => {
    return state.applications.byId[id];
  },
  [CLIENTS_LOADED]: state => {
    return state.clients.allIds.length;
  },
  [GET_CURRENT_FILTERS]: state => {
    return {
      board: state.clientsTableFilters.board,
      read: state.clientsTableFilters.read,
      status: state.clientsTableFilters.status
    };
  },
  [GET_CLIENT_INFORMATION_FOR_TRANSFER]: state => ({
    clientUsername
  }) => {
    const {
      givenName,
      familyName,
      email,
      agentUsername: ownerUsername,
      latestApplicationId,
      phoneNumber
    } = state.clients.byId[clientUsername];
    const {
      mortgageRenewalDate = null,
      dateOfBirth = null
    } = state.applications.byId[latestApplicationId];
    return {
      clientUsername,
      givenName,
      familyName,
      email,
      ownerUsername,
      applicationId: null,
      phoneNumber,
      mortgageRenewalDate,
      dateOfBirth
    };
  },
  [SHOULD_VERIFY_IMPORT_EMAIL]: state => {
    return state.import.shouldVerifyEmail;
  },
  [IMPORT_VERIFICATION_EMAIL]: state => {
    return state.import.verificationEmail;
  }
};